export default "__VITE_ASSET__CgUmgOaX__";